export const borders = {
  none: 0,
  sm: '1px solid',
  md: '2px solid',
  lg: '4px solid',
};
